import { render, staticRenderFns } from "./SiteItem.vue?vue&type=template&id=54823a1d&scoped=true&"
import script from "./SiteItem.vue?vue&type=script&lang=js&"
export * from "./SiteItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteItem.vue?vue&type=style&index=0&id=54823a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54823a1d",
  null
  
)

export default component.exports